import axios from 'axios'
import router from "../router";
import store from "../store"
import fa from "element-ui/src/locale/lang/fa";
import de from "element-ui/src/locale/lang/de";
import { openLoading, closeLoading } from '../utils/utils';
// 配置请求的根路径
axios.defaults.baseURL = process.env.BASE_URL;

// axios.headers()
// 通过axios 请求拦截器添加token，保证有获取数据的权限
axios.interceptors.request.use(config => {
 
    if (config.headers && config.headers['Content-Type'] && config.headers['Content-Type'].includes('application/json')) {
        if (typeof config.data === 'object' && config.data !== null) {
            config.data = JSON.stringify(config.data);
        }
    }
    config.headers = config.headers || {};
    config.headers['Content-Type'] = config.headers['Content-Type'] || 'application/json; charset=UTF-8;';
    // 为请求头对象，添加token验证的Authorization 字段
    // console.log('链接请求')
    // console.log(config.url, config.url.indexOf("find"))
    // if (config.url != '/api/lm/web/webLog/insertByBatch' && config.url.indexOf('children') < 0 && config.url.indexOf("find") < 0 &&
    //     config.url.indexOf('query') < 0 && config.url.indexOf('user-bank/select/extend') < 0) {
    //     openLoading()
    // }
    // setTimeout(function() {
    //     closeLoading()
    // }, 10000);
    var token = localStorage.getItem('token');
    let userInfo = localStorage.getItem("login");

    if (config.url.search('au/login') < 0 && config.url.search('verification/mobile') < 0 && config.url.search('au/company/register') < 0) {
        config.headers.Authorization = token;
        if (userInfo) {
            config.headers.userId = JSON.parse(userInfo).userId;
        }
    } else {
        config.headers.Authorization = "";
    }
    return config
});

/**
 * 图片上传用这个
 * @type {AxiosInstance}
 */
const fileAxios = axios.create({
    baseURL: process.env.BASE_URL,
    timeout: 180000, // 3min
    headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": localStorage.getItem('token')
    }
});


var isInterceptorLogin = true; //是否需要拦截登录
axios.interceptors.response.use(
    response => {
        //如果response中出现x-token-refresh，将token值替换
        // console.log(response, response.headers['x-token-refresh'], response.headers['x-token'])
        if (response.headers['x-token-refresh']) {
            localStorage.setItem('token', response.headers['x-token'])
        }
        closeLoading()
        if (response.status == 502) {
            return Promise.reject({
                data: {
                    retDesc: "系统未启动，请稍候..."
                }
            });
        }
        var sharing = store.state.sharing;
        if (response.data.retCode == 401) {
            // debugger
            if (!sharing) {
                router.push({
                    path: '/login',
                })
            } else if (sharing.routes.length < 1) {
                router.push({
                    path: '/login',
                })
            } else {
                
                var userType = sharing.userInfo.userType;
                if (userType == 1) {
                    router.push({
                        path: '/login',
                    })
                } else if (userType == 2) {
                    //承运
                    router.push({
                        path: '/login_carr',
                    })
                } else {
                    //托运
                    router.push({
                        path: '/login_shipper',
                    })
                }
            }

            sessionStorage.removeItem("token");
            sessionStorage.removeItem("userInfo");
            delete axios.defaults.headers.common['Authorization'];

        }
        if( response.data.infocode && response.data.infocode != '10000') {
            return Promise.reject(response == '系统异常' ? '遇到点小问题，已反馈技术处理，请稍后再试~' : response);
        }else if (response.data.retCode && response.data.retCode !== '0000000' && !response.data.type) {
            return Promise.reject(response == '系统异常' ? '遇到点小问题，已反馈技术处理，请稍后再试~' : response);
        }else {
            return response;
        }
    },
    error => {
        return Promise.reject(error == '系统异常' ? '遇到点小问题，已反馈技术处理，请稍后再试~' : error)
    }
)

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export const get = (url, param = {}, ops) => {
    return new Promise((resolve, reject) => {
        let params = paramsBeforeSend(param);
        axios.get(url, params, ops)
            .then(res => {
                resolve(res.data.rspBody);
            })
            .catch(err => {
                reject(err == '系统异常' ? '遇到点小问题，已反馈技术处理，请稍后再试~' : err)
            })
    })
}

export const get1 = (url, param = {}, ops) => {
    return new Promise((resolve, reject) => {
        let params = paramsBeforeSend(param);
        axios.get(url, params, ops)
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                reject(err == '系统异常' ? '遇到点小问题，已反馈技术处理，请稍后再试~' : err)
            })
    })
}
/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export const post = (url, data = {}, ops) => {
    // console.log(url);

    return new Promise((resolve, reject) => {
        let params = paramsBeforeSend(data);
        axios.post(url, params, ops)
            .then(res => {
                resolve(res.data.rspBody);

            })
            .catch(err => {
                reject(err == '系统异常' ? '遇到点小问题，已反馈技术处理，请稍后再试~' : err)
                // console.log(err);

            })
    })
};

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

//封装post1 res可以拿到data headers所有数据
export const post1 = (url, data = {}, ops) => {
    console.log(url, data, ops);

    return new Promise((resolve, reject) => {
        let params = paramsBeforeSend(data);
        axios.post(url, params, ops)
            .then(res => {
                resolve(res);

            })
            .catch(err => {
                reject(err == '系统异常' ? '遇到点小问题，已反馈技术处理，请稍后再试~' : err)
            })
    })
};

function removeQuotes(str) {
    if ((str.startsWith('"') && str.endsWith('"')) || 
        (str.startsWith("'") && str.endsWith("'"))) {
        return str.substring(1, str.length - 1);
    }
    return str;
}
//封装post1 res可以拿到data headers所有数据
export const postGd = (url, data = "", ops) => {
    console.log(url, data, ops);
    if (!ops) {
        ops = {
            headers: {
                "Content-Type": 'text/plain',
            }
        }
    }
    return new Promise((resolve, reject) => {
        const params = removeQuotes(data);
        axios.post(url, params, ops)
            .then(res => {
                resolve(res.data);

            })
            .catch(err => {
                reject(err == '系统异常' ? '遇到点小问题，已反馈技术处理，请稍后再试~' : err)
            })
    })
};


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

//封装post1 res可以拿到data headers所有数据
export const post2 = (url, data = {}, ops) => {
    return new Promise((resolve, reject) => {
        let params = data;
        axios.post(url, params, ops)
            .then(res => {
                resolve(res);

            })
            .catch(err => {
                reject(err == '系统异常' ? '遇到点小问题，已反馈技术处理，请稍后再试~' : err)
            })
    })
};

//封装post3 传参给后端的空字符串过滤的情况给去掉
export const post3 = (url, data = {}, ops) => {
    return new Promise((resolve, reject) => {
        let params = data;
        axios.post(url, params, ops)
            .then(res => {
                resolve(res.data.rspBody);

            })
            .catch(err => {
                reject(err == '系统异常' ? '遇到点小问题，已反馈技术处理，请稍后再试~' : err)
            })
    })
};


export const dict = (code) => {
    return post("/api/md/dict/children", { rootCode: code });
}

/**
 * 图片上传，不含OCR
 * 文件上传
 *
 * @param option
 * @returns {Promise} 仅返回图片的地址
 */
export const upload = (option) => {
    return new Promise((resolve, reject) => {
        const params = new FormData();
        params.append(option.filename, option.file, option.file.name); //通过append向form对象添加数据
        fileAxios({
            url: '/api/file/upload',
            method: "post",
            data: params
        }).then(res => {
            //
            if (res.data.retCode === "0000000") {
                if (res.data.rspBody && res.data.rspBody[0] && res.data.rspBody[0].url) {
                    resolve(res.data.rspBody[0].url);
                } else {
                    reject("无法获取到图片地址")
                }
            } else {
                reject(res.data.retDesc == '系统异常' ? '遇到点小问题，已反馈技术处理，请稍后再试~' : res.data.retDesc)
            }
        }).catch(err => {
            reject(err == '系统异常' ? '遇到点小问题，已反馈技术处理，请稍后再试~' : err)
        });
    })
}

export const download = (url, data = {}, ops) => {
    data.pageNum = undefined;
    data.pageSize = undefined;
    return new Promise((resolve, reject) => {
        fileAxios.post(url, data, {
            responseType: 'blob', // 设置响应数据类型
            headers: {
                "Authorization": localStorage.getItem('token'),
                "Content-Type": 'application/json; charset=UTF-8;'
            }
        }).then(res => {
            console.log(res,'下载');
            if (res.status === 200) {
                // console.log(res.headers)
                const disposition = res.headers['content-disposition'];
                // 拿到文件名
                let filename = disposition.split('filename=')[1];
                filename = filename ? decodeURI(filename): filename;
                let blob = new Blob([res.data]);
                // 兼容ie
                if ('msSaveOrOpenBlob' in navigator) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    const URL = window.URL || window.webkitURL;
                    let objectUrl = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = objectUrl;
                    a.download = filename;
                    a.click();
                    URL.revokeObjectURL(objectUrl);
                }
            }
        }).catch(err => {
            reject(err == '系统异常' ? '遇到点小问题，已反馈技术处理，请稍后再试~' : err)
        })
    })
}

export const download1 = (url, data = {}, ops) => {
    return new Promise((resolve, reject) => {
        fileAxios.post(url, data, {
            responseType: 'blob', // 设置响应数据类型
            headers: {
                "Authorization": localStorage.getItem('token'),
                "Content-Type": 'application/json; charset=UTF-8;'
            }
        }).then(res => {
            if (res.status === 200) {
                // console.log(res.headers)
                const disposition = res.headers['content-disposition'];
                // 拿到文件名
                let filename = disposition.split('filename=')[1];
                let blob = new Blob([res.data]);
                // 兼容ie
                if ('msSaveOrOpenBlob' in navigator) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    const URL = window.URL || window.webkitURL;
                    let objectUrl = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = objectUrl;
                    a.download = filename;
                    a.click();
                    URL.revokeObjectURL(objectUrl);
                }
            }
        }).catch(err => {
            reject(err == '系统异常' ? '遇到点小问题，已反馈技术处理，请稍后再试~' : err)
        })
    })
}
export const download2 = (url, data = {}, ops) => {
    return new Promise((resolve, reject) => {
        fileAxios.post(url, data, {
            responseType: 'blob', // 设置响应数据类型
            headers: {
                "Authorization": localStorage.getItem('token'),
                "Content-Type": 'application/json; charset=UTF-8;'
            }
        }).then(res => {
            if (res.status === 200) {
                // console.log(res.headers)
                const disposition = res.headers['content-disposition'];
                // 拿到文件名
                let filename = disposition.split('filename=')[1];
                filename = filename ? decodeURI(filename): filename;
                let blob = new Blob([res.data]);
                // 兼容ie
                if ('msSaveOrOpenBlob' in navigator) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    const URL = window.URL || window.webkitURL;
                    let objectUrl = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = objectUrl;
                    a.download = filename;
                    a.click();
                    URL.revokeObjectURL(objectUrl);
                }
            }
        }).catch(err => {
            reject(err == '系统异常' ? '遇到点小问题，已反馈技术处理，请稍后再试~' : err);
        })
    })
}

const paramsBeforeSend = (params) => {
    if (typeof params === "object" && !Array.isArray(params)) {
        let result = {};
        let tmp = '';
        for (let key in params) {
            if (params[key] || params[key] === 0 || params[key] === '0') {
                tmp = params[key];
                if (typeof tmp == 'string') {
                    result[key] = tmp.replace(/(^\s*)|(\s*$)/g, "")
                } else {
                    result[key] = tmp;
                }
            }
        }
        return result;
    }
    return params;
};




// WEBPACK FOOTER //
// ./src/api/ajax.js